<style lang="stylus" scoped>
    .recommend-searchpage
        width 100%
        padding 24px 0 24px 16px
        .searchpage-back
            display flex
            align-items center
            width fit-content
            height 32px
            margin-bottom 16px
            margin-left 24px
            cursor pointer
            user-select none
            svg
                width 16px
                height 16px
                margin-right 4px
                color #424242
            p
                color #000
                font-size 16px
                font-weight 700
        .searchpage-text
            margin-left 24px
            margin-bottom 24px
            color #222
            font-size 14px
            .searchpage-key
                font-weight 700
        .searchpage-list
            display flex
            flex-wrap wrap
            row-gap 4px
            .searchpage-file-loading
                width 100%
                height 100%
                min-height 400px
                display flex
                align-items center
                justify-content center
                svg
                    width 40px
                    height 40px
            .searchpage-file
                display flex
                align-items center
                width 100%
                height 56px
                border-radius 6px
                padding 0 24px
                margin-right 40px
                cursor pointer
                user-select none
                &:hover
                    background #F2F4F999
                .searchpage-filename
                    display flex
                    align-items center
                    flex 1
                    img
                        width 32px
                        height 32px
                        margin-right 8px
                    p
                        font-size 12px
                        color #222
                        &.blue
                            color #017fff
                .searchpage-filedate
                    width 30%
                    color #00000080
                .searchpage-filesize
                    width 10%
                    color #00000080
        .searchpage-row-title
            font-size 16px
            color #222
            margin-bottom 16px
        .searchpage-class
            margin 0 24px
            margin-bottom 32px
            /deep/.searchpage-lv2
                margin-top 0
                .lv2-title
                    display none
                .scroll-control
                    top 0

        .searchpage-template
            margin 0 24px
            margin-bottom 32px
            /deep/.searchpage-templates
                min-height none
                padding-bottom 0
                .recommend-templates
                    margin-top 0
                    .template-title
                        display none
        .searchpage-store
            margin 0 24px

        .searchpage-empty
            flex-grow 1
            display flex
            flex-direction column
            justify-content center
            align-items center
            padding 64px 0 80px 0
            &.searchpage-empty-nottem
                padding-top 184px
            img
                width 140px
                margin-bottom 8px
            p
                font-size 12px
                color #22222266
                .searchpage-empty-key
                    color #222
</style>

<template>
    <ScrollView ref="scrollView">
        <div class="recommend-searchpage">
            <div class="searchpage-back" @click="backToHome()">
                <iconSymbol name="recommend-back" />
                <p>{{ $t("back") }}</p>
            </div>

            <div class="searchpage-text">
                <i18n path="result" tag="p">
                    <template #key>
                        <span class="searchpage-key">{{ searchStr }}</span>
                    </template>
                    <!-- <template #num>
                        <span>{{ searchResultNum }}</span>
                    </template> -->
                </i18n>
            </div>

            <div v-if="showEmpty" class="searchpage-empty" :class="{ 'searchpage-empty-nottem': works.length == 0 }">
                <img src="@/home/assets/img/newPage/recommend-new/search-empty.svg" alt="" />
                <i18n v-if="searchType == 'template'" path="searchEmpty" tag="p">
                    <template #key>
                        <span class="searchpage-empty-key">{{ searchStr }}</span>
                    </template>
                </i18n>
                <p v-else>{{ $t("searchFileEmpty") }}</p>
            </div>

            <div v-if="searchType == 'file'" class="searchpage-list">
                <div v-if="showFileLoading" class="searchpage-file-loading">
                    <svg
                        version="1.1"
                        id="loader-1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px"
                        y="0px"
                        width="50px"
                        height="50px"
                        viewBox="0 0 50 50"
                        style="enable-background: new 0 0 50 50"
                        xml:space="preserve"
                    >
                        <path
                            fill="#017fff"
                            d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z"
                        >
                            <animateTransform
                                attributeType="xml"
                                attributeName="transform"
                                type="rotate"
                                from="0 25 25"
                                to="360 25 25"
                                dur="0.8s"
                                repeatCount="indefinite"
                            />
                        </path>
                    </svg>
                </div>
                <div class="searchpage-file" v-for="item in list" :key="item.id" @click="openSearchPageFile(item)">
                    <div class="searchpage-filename">
                        <img src="@/home/assets/img/newPage/recommend-new/file.svg" alt="" />
                        <p v-for="text in item.nameList" :key="text" :class="{ blue: text == searchStr }">{{ text }}</p>
                    </div>
                    <div class="searchpage-filedate">{{ formatDate(item.lastModified) }}</div>
                    <div class="searchpage-filesize">{{ renderSize(item.size) }}</div>
                </div>
            </div>

            <template v-else>
                <div v-show="lv2List.length > 0" class="searchpage-class">
                    <p class="searchpage-row-title">{{ $t("classTitle") }}</p>
                    <RecommendLv2 class="searchpage-lv2" :list="lv2List" :from="'searchpage'" @clickLv2="clickLv2" />
                </div>

                <div v-show="displayTemplateList.length > 0" class="searchpage-template">
                    <p class="searchpage-row-title">{{ $t("templateTitle") }}</p>
                    <RecommendTemplate
                        ref="templateDom"
                        class="searchpage-templates"
                        :list="displayTemplateList"
                        :fromSearch="true"
                        @openTemplate="openTemplate"
                    />
                </div>

                <div v-show="works.length > 0" class="searchpage-store">
                    <p class="searchpage-row-title">{{ $t("storeTitle") }}</p>
                    <tplWaterfall ref="waterfall" :works="works" type="searchPage" @openTemplate="openTemplate" @trackTemplate="trackTemplate" />
                </div>
            </template>
        </div>
    </ScrollView>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch, Mixins } from "vue-property-decorator";
    import ScrollView from "@/public/components/ScrollView/ScrollView.vue";
    import RecommendLv2 from "./recommend-lv2.vue";
    import RecommendTemplate from "./recommend-template.vue";
    import tplCenter from "@/home/mixins/tplCenter";
    import fileItem from "@/home/parts/fileItem";
    import { safeEncodeURIComponent } from "@/public/utils/tool.js";
    @Component({
        components: {
            ScrollView,
            RecommendLv2,
            RecommendTemplate,
        },
    })
    export default class RecommendSearchpage extends Mixins(tplCenter, fileItem) {
        searchStr = "";
        searchType = "";
        showEmpty = false;
        showFileLoading = false;
        get searchResultNum() {
            let len = 0;
            if (this.searchType == "file") {
                len = this.list.length;
            } else {
                len = this.lv2List.length + this.displayTemplateList.length + this.works.length;
            }

            if (len > 99) {
                return "99+";
            } else {
                return len;
            }
        }
        formatDate(str) {
            const addZero = (num) => {
                return (num < 10 && `0${num}`) || num;
            };
            let date = new Date(str);
            let Y = date.getFullYear();
            let M = date.getMonth() + 1;
            let D = date.getDate();
            let H = date.getHours();
            let Min = date.getMinutes();
            let sec = date.getSeconds();
            return `${Y}/${addZero(M)}/${addZero(D)} ${addZero(H)}:${addZero(Min)}:${addZero(sec)}`;
        }
        renderSize(size) {
            let s = size / 1024 / 1024;
            if (s > 1) {
                return s.toFixed(2) + "M";
            } else {
                return (size / 1024).toFixed(0) + "KB";
            }
        }
        backToHome() {
            this.$router.go(-1);
        }
        filterSearchKey(str) {
            return str
                .replace(new RegExp(`${this.searchStr}`, "g"), `%%${this.searchStr}%%`)
                .split("%%")
                .filter((item) => item != "");
        }
        list = [];
        searchData() {
            this.showFileLoading = true;
            this.showEmpty = false;
            this.$store
                .dispatch("searchFile", { value: this.searchStr })
                .then((res) => {
                    res.data.data.map((item) => {
                        let filePath: any = [];
                        filePath = item.key.match(/[^\/]+\/[^\/]+\/(.+)/) && item.key.match(/[^\/]+\/[^\/]+\/(.+)/)[1];
                        filePath = filePath.split("/");
                        let name = filePath.pop();
                        filePath = filePath.length ? this.$t("personal") + ">" + filePath.join(">") : this.$t("personal");
                        name = name.match(/(.*)\.eddx/) && name.match(/(.*)\.eddx/)[1];
                        item.name = name;
                        item.nameList = this.filterSearchKey(name);
                    });

                    this.list = res.data.data;

                    if (this.list.length == 0) {
                        this.showEmpty = true;
                    }
                    this.sensors.track("searchResult", {
                        Catalogues: "searchMainpage",
                        search_space: "enter",
                        search_value: this.list.length > 0 ? "cloud_file" : "none",
                    });
                })
                .catch((err) => {
                    this.list = [];
                })
                .finally(() => {
                    this.showFileLoading = false;
                });
        }

        // 模板
        lv2List = [];
        displayTemplateList = [];
        searchTemplate() {
            this.showEmpty = false;
            return new Promise((rs, rj) => {
                this.$edApi
                    .searchTem2({
                        name: this.searchStr,
                        offset: 0,
                        count: 100,
                        lang: this.lang,
                    })
                    .then((res) => {
                        let subClassList = res.data.data.sub_class.list;
                        let templateList = res.data.data.template.list;
                        if (subClassList.length == 0 && templateList.length == 0) {
                            this.showEmpty = true;
                            rs("");
                        } else {
                            let arr2 = subClassList.map((item) => {
                                item.img_url = window["GLOBAL"].PUBLIC_OSS_HOST + safeEncodeURIComponent(item.img_url);
                                return item;
                            });
                            this.lv2List = arr2;
                            this.displayTemplateList = templateList.map((v) => {
                                v.img_url = window["GLOBAL"].PUBLIC_OSS_HOST + safeEncodeURIComponent(v.img_url);
                                return v;
                            });
                            let str = this.lv2List.length > 0 ? "diagram_type" : "";
                            let str2 = this.displayTemplateList.length > 0 ? "template" : "";
                            rs(str && str2 ? `${str}&${str2}` : str ? str : str2 ? str2 : "");
                        }
                    });
            });
        }
        clickLv2(item) {
            (this.$refs.templateDom as any).createEmptyFile(item.libs);
            this.sensors.track("searchResultNewBlankFile", {
                Catalogues: "searchMainpage",
                new_blank_file_way: "clickdiagramtype",
            });
        }

        storeLoading = false;
        storeOffset = 0;
        storeEnd = false;
        searchStoreTemplate() {
            if (this.storeLoading || this.storeEnd) return;
            this.storeLoading = true;
            const obj = {
                search: this.searchStr,
                offset: this.storeOffset,
                count: 30,
                order: "PV",
                sort: "DESC",
                lang: this.lang,
                classId: 0,
                tag: [],
                price: 1,
            };

            this.storeOffset += 30;

            return new Promise((rs, rj) => {
                this.$edApi
                    .getPublish(obj)
                    .then(({ data }) => {
                        console.log(data);
                        if (data.length == 0) {
                            this.storeEnd = true;
                        }
                        this.updateWaterfall(
                            {
                                works: data,
                                noCache: null,
                                callback: () => {
                                    (this.$refs.scrollView as any).update();
                                },
                            },
                            true
                        );
                        if (data.length > 0) {
                            rs("community_template");
                        } else {
                            rs("");
                        }
                    })
                    .catch((err) => {})
                    .finally(() => {
                        this.storeLoading = false;
                    });
            });
        }
        scrollAdd() {
            if (this.storeLoading) return;
            let con = (this.$refs.scrollView as any).$el.children[0];
            if (con.scrollHeight - (con.scrollTop + con.offsetHeight) < 30) {
                this.searchStoreTemplate();
            }
        }

        count = 0;
        openTemplate(action = "create_new") {
            this.count++;

            this.sensors.track("searchResultClickTemplate", {
                Catalogues: "searchMainpage",
                order: this.count,
                action,
            });
        }

        trackTemplate(action) {
            this.sensors.track("searchResultClickTemplate", {
                Catalogues: "searchMainpage",
                order: this.count,
                action,
            });
        }

        openSearchPageFile(item) {
            this.openFiles(item);
            this.sensors.track("searchResultClickFile", {
                Catalogues: "searchMainpage",
                value: item.name,
            });
        }

        created() {}
        async mounted() {
            this.searchStr = this.$route.query.search as string;
            this.searchType = this.$route.query.type as string;
            if (this.searchType == "file") {
                this.searchData();
            } else {
                let tStr = await this.searchTemplate();
                let sStr = await this.searchStoreTemplate();
                let trackStr = [tStr, sStr].filter((item) => item != "").join("&");
                this.sensors.track("searchResult", {
                    Catalogues: "searchMainpage",
                    search_space: "enter",
                    search_value: trackStr || "none",
                });
            }
            this.$nextTick(() => {
                (this.$refs.scrollView as any).$el.children[0].addEventListener("scroll", this.scrollAdd);
            });
        }
        beforeDestroy() {
            let con = (this.$refs.scrollView as any).$el.children[0];
            con.removeEventListener("scroll", this.scrollAdd);
        }
    }
</script>
<i18n>
{
    "zh": {
        "back": "返回",
        "result": "\"{key}\" 的搜索结果",
        "classTitle": "绘图类型",
        "templateTitle": "精选模板",
        "storeTitle": "社区模板",
        "searchEmpty": "很抱歉，没有找到“{key}”下面相关的模板，下面是我们为您推荐的模板，可以尝试一下~",
        "searchFileEmpty": "无匹配文件"
    },
    "en": {
        "back": "Back",
        "result": "Search results for \"{key}\"",
        "classTitle": "Drawing Type",
        "templateTitle": "Featured Templates",
        "storeTitle": "Community Templates",
        "searchEmpty": "Sorry, no templates related to \"{key}\" were found. We recommend trying the following templates:",
        "searchFileEmpty": "No matching files found"
    },
    "fr": {
        "back": "Retour",
        "result": "Résultats de la recherche pour « {key} »",
        "classTitle": "Type de dessin",
        "templateTitle": "Modèles en vedette",
        "storeTitle": "Modèles de la communauté",
        "searchEmpty": "Désolé, aucun modèle associé à « {key} » n'a été trouvé. Essayez les modèles suivants :",
        "searchFileEmpty": "Aucun fichier correspondant trouvé"
    },
    "de": {
        "back": "Zurück",
        "result": "Suchergebnisse für „{key}“",
        "classTitle": "Zeichnungstyp",
        "templateTitle": "Empfohlene Vorlagen",
        "storeTitle": "Community-Vorlagen",
        "searchEmpty": "Es wurden leider keine Vorlagen zu „{key}“ gefunden. Wir empfehlen die folgenden Vorlagen:",
        "searchFileEmpty": "Keine übereinstimmenden Dateien gefunden"
    },
    "jp": {
        "back": "戻る",
        "result": "「{key}」の検索結果",
        "classTitle": "図面タイプ",
        "templateTitle": "おすすめのテンプレート",
        "storeTitle": "コミュニティテンプレート",
        "searchEmpty": "申し訳ございません、「{key}」に関連するテンプレートは見つかりませんでした。次のテンプレートをお試しください。",
        "searchFileEmpty": "一致するファイルが見つかりません"
    },
    "es": {
        "back": "Volver",
        "result": "Resultados de la búsqueda de \"{key}\"",
        "classTitle": "Tipo de dibujo",
        "templateTitle": "Plantillas destacadas",
        "storeTitle": "Plantillas de la comunidad",
        "searchEmpty": "Lo sentimos, no hemos encontrado plantillas relacionadas con \"{key}\". Te recomendamos estas otras plantillas:",
        "searchFileEmpty": "No se han encontrado archivos coincidentes."
    },
    "pt": {
        "back": "De volta",
        "result": "Resultados da pesquisa para \"{key}\"",
        "classTitle": "Tipo de desenho",
        "templateTitle": "Modelos em destaque",
        "storeTitle": "Modelos de comunidade",
        "searchEmpty": "Desculpe, nenhum modelo relacionado a \"{key}\" foi encontrado. Recomendamos que você tente os seguintes modelos:",
        "searchFileEmpty": "Nenhum arquivo correspondente encontrado"
    },
    "it": {
        "back": "Aggiorna",
        "result": "Cerca risultati per \"{key}\"",
        "classTitle": "Tipo di disegno",
        "templateTitle": "Modelli in primo piano",
        "storeTitle": "Modelli della community",
        "searchEmpty": "Spiacenti, non è stato trovato nessun modello correlato a \"{key}\". Ti consigliamo di provare i modelli seguenti:",
        "searchFileEmpty": "Non è stato trovato nessun file corrispondente"
    },
    "tw": {
    },
    "kr": {
    }
}
</i18n>
